export class VersionsResponse {
    public code?: number;
    public response?: VersionResponse;
}

export class VersionResponse {
    public android?: string;
    public ios?: string;
}